import React, { useState, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';

const BenefitsConcierge: React.FC = () => {
  const { user } = useAuth0();
  const [loading, setLoading] = useState(true);
  const [urlKey, setUrlKey] = useState('');
  const [forceReload, setForceReload] = useState(0);

  // Generate URL key on mount and user change
  useEffect(() => {
    setUrlKey(`&nocache=${Date.now()}`);
  }, [user]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      setUrlKey('');
      // Clear any local storage if needed
    };
  }, []);

  // // Optional: Heartbeat check for session
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     // Force reload if we detect issues
  //     const chatElement = document.querySelector('iframe')?.contentWindow;
  //     if (!chatElement) {
  //       setForceReload(prev => prev + 1);
  //     }
  //   }, 30000);

  //   return () => clearInterval(interval);
  // }, []);

  // Hard-coded plan or some config
  const plan_id = 'HPI|D2453U3M001';
  const patientID = 'CTX928376139'
  const userName = encodeURIComponent(user?.email || 'demo@demo.com');
  const givenName = encodeURIComponent(user?.given_name || user?.name || 'Guest');
  const lsq_tenant = 'sandbox'
  const congruity_token = 'null'

  const BENEFITS_URL = `https://agents.congruityhealth.com/?agent=Benefits_Advisor&plan_id=${plan_id}&user_name=${userName}&given_name=${givenName}&patientID=${patientID}&congruity_token=${congruity_token}&lsq_tenant=${lsq_tenant}${urlKey}&allowCredentials=true`;

  const handleLoad = () => setLoading(false);

  // Handle session error detection
  const handleError = () => {
    console.log('Session error detected, reloading...');
    setForceReload(prev => prev + 1);
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: "8vh",
        width: '100%',
        height: 'calc(100dvh - 15vh)',
        overflow: 'hidden',
        mt: 0,
        mb: 0,
        p: 0
      }}
    >
      {loading && (
        <Box
        >
          <CircularProgress />
        </Box>
      )}
 
      <iframe
        title="Benefits Advisor"
        src={BENEFITS_URL}
        style={{
          border: 'none',
          transform: 'scale(0.75)',
          transformOrigin: 'top left',
         width: '133%',
         height: '133%'
        }}
        onLoad={handleLoad}
        onError={handleError}
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-storage-access-by-user-activation"
        loading="eager"
        key={`drbill-${urlKey}-${forceReload}`}
      />
    </Box>
  );
 };
 

export default BenefitsConcierge;